import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description = "Gifted Academy Tutors provides personalized one-on-one tutoring in Math, Physics, Chemistry, and IB programs in Toronto. Book a session today.", 
  keywords = "tutoring, math tutoring, physics tutoring, chemistry tutoring, IB tutoring, Toronto tutoring, online tutoring",
  canonicalUrl,
  ogImage = 'https://giftedacademytutors.ca/og-image.png'
}) => {
  const siteName = 'Gifted Academy Tutors';
  const defaultTitle = 'Math, Science & IB Tutoring in Toronto';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | ${defaultTitle}`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content={siteName} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
};

export default SEO;
